import React from 'react';
import './VoicemailRetrySettings.css';

/**
 * Triggered campaigns: same visual shell as Duplicate data rule (grey box, kt-switch, description text).
 * On = webhook sends call_group (call group). Off = customers only (individual).
 */
export default function CallGroupWebhookToggleSection({
    acceptCallGroup,
    onAcceptChange,
    disabled = false,
    idPrefix = 'call-group-webhook',
    footer = null,
    chromeless = false,
    hideDescription = false,
}) {
    return (
        <div
            className={`voicemail-retry-settings duplicate-data-rule-voicemail-shell${
                chromeless ? ' voicemail-retry-settings--chromeless' : ''
            }${disabled ? ' duplicate-data-rule-voicemail-shell--disabled' : ''}`}
        >
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group voicemail-retry-toggle">
                        <div className="voicemail-retry-toggle-wrapper">
                            <label className="voicemail-retry-toggle-label mb-0" htmlFor={`${idPrefix}-toggle`}>
                                Accept call group in webhook
                            </label>

                            <span
                                className={
                                    acceptCallGroup
                                        ? 'kt-switch kt-switch-sm kt-switch--success chat-cus-check voicemail-retry-switch'
                                        : 'kt-switch kt-switch-sm kt-switch--error chat-cus-check voicemail-retry-switch'
                                }
                            >
                                <label>
                                    <input
                                        type="checkbox"
                                        id={`${idPrefix}-toggle`}
                                        checked={!!acceptCallGroup}
                                        onChange={(e) => onAcceptChange(e.target.checked)}
                                        disabled={disabled}
                                    />
                                    <span />
                                </label>
                            </span>
                        </div>
                    </div>

                    {!hideDescription && (
                        <p className="rules-match-voicemail-desc mb-1">
                            <strong>{acceptCallGroup ? 'Call group' : 'Individual'}</strong>
                            {acceptCallGroup
                                ? ': webhook payloads use a call_group array (priority / required). Do not mix customers and call_group in one request.'
                                : ': webhook payloads use a customers array (one contact per row).'}
                        </p>
                    )}

                    {footer != null && footer !== false && (
                        <div
                            className="duplicate-data-rule-voicemail-shell__footer mt-3 pt-3"
                            style={{ borderTop: '1px solid #e9ecef' }}
                        >
                            {footer}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
